import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
  Alert,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalFormUser({
  userSelect,
  callback,
  title,
  button_text,
  button_variant,
}) {
  const [show, setShow] = useState(false);
  const [profiles, setProfile] = useState([]);
  const [office, setOffice] = useState([]);
  const [infoForm, setForm] = useState({
    first_name: '',
    last_name: '',
    profile: '',
    email: '',
    office: '',
    state: true,
    cpass: '',
    confirmpass: '',
    document: '',
  });
  const [alert, setAlert] = useState({
    show: false,
    message: '',
  });

  const handleClose = () => {
    setShow(false)
    setAlert({ show: false, message: '' })
  };
  const handleShow = async (user) => {
    if (user) {
      const infouser = await get('/users/' + user);
      if (infouser.success) {
        const { first_name, last_name, email, document, state, profile, office } =
          infouser.data;
        setForm({
          first_name,
          last_name,
          profile,
          email,
          office,
          state,
          document,
          cpass: '',
          confirmpass: '',
        });
      }
    }
    setShow(true);
  };

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    let respo,
      variant = '',
      msg = '';
    const body = { ...infoForm };
    if (userSelect) {
      if (infoForm.cpass !== '' || infoForm.confirmpass !== '') {
        if (infoForm.cpass === infoForm.confirmpass) {
          respo = await put('/users/modify/' + userSelect, body);
          msg = 'Usuario editado Correctamente';
        } else {
          respo = {
            success: false,
            message: "Password y confirmacion no concuerdan"
          }
        }
      } else {
        respo = await put('/users/modify/' + userSelect, body);
        msg = 'Usuario editado Correctamente';
      }
    } else {
      respo = await post('/users/create', body);
      msg = 'Usuario Creado Correctamente';
    }

    if (respo.success) {
      variant = 'success';
      setForm({
        first_name: '',
        last_name: '',
        profile: '',
        email: '',
        document: '',
        office: '',
        state: true,
      });
      handleClose();
      setAlert({ show: false, message: '' })
      callback(variant, msg);
    } else {
      variant = 'danger';
      msg = respo.message;
      setAlert({ show: true, message: msg });
    }

  };

  useEffect(() => {
    if (show) {
      getProfile();
      getOffice();
    }
  }, [show]);

  const getProfile = async () => {
    const responseprofile = await get('/profile/', {});
    if (responseprofile.success) {
      setProfile(responseprofile.data);
    } else {
      setAlert({ show: true, message: responseprofile.message });
    }
  };

  const getOffice = async () => {
    const responseoffice = await get('/office/', {});
    if (responseoffice.success) {
      setOffice(responseoffice.data);
    } else {
      setAlert({ show: true, message: responseoffice.message });
    }
  };
  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow(userSelect)}
      />

      <Modal animation={false} fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {alert.show && (
            <Alert
              variant="danger"
              onClose={() => setAlert({ show: false })}
              dismissible
            >
              {alert.message}
            </Alert>
          )}

          <Container>
            <Form.Label htmlFor="nombre">Nombre</Form.Label>
            <Form.Control
              name="first_name"
              value={infoForm.first_name}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            <Form.Label htmlFor="Apellido">Apellido</Form.Label>
            <Form.Control
              name="last_name"
              value={infoForm.last_name}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            <Form.Label htmlFor="Email">email</Form.Label>
            <Form.Control
              name="email"
              value={infoForm.email}
              onChange={(e) => handleForm(e)}
              type="email"
            />
            <Form.Label htmlFor="document">Numero Documento</Form.Label>
            <Form.Control
              name="document"
              value={infoForm.document}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            <Form.Label htmlFor="profile">Perfil</Form.Label>
            <Form.Select
              name="profile"
              value={infoForm.profile}
              onChange={(e) => handleForm(e)}
              aria-label="Default select example"
            >
              <option value="">Seleccione</option>
              {profiles.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
            <Form.Label htmlFor="Office">sucursal</Form.Label>
            <Form.Select
              name="office"
              value={infoForm.office}
              onChange={(e) => handleForm(e)}
              aria-label="Default select example"
            >
              <option value="">Seleccione</option>
              {office.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
            <Form.Check
              className="mb-4"
              type="switch"
              name="state"
              label="Activo"
              checked={infoForm.state}
              onChange={(e) => handleForm(e)}
            />

            <Form.Label htmlFor="cpass">Nuevo Password</Form.Label>
            <Form.Control
              autoComplete="off"
              name="cpass"
              value={infoForm.cpass}
              onChange={(e) => handleForm(e)}
              type="password"
            />
            <Form.Label htmlFor="confirmpass">Confirmar Password</Form.Label>
            <Form.Control
              autoComplete="off"
              name="confirmpass"
              value={infoForm.confirmpass}
              onChange={(e) => handleForm(e)}
              type="password"
            />

            <Row className="text-center m-3">
              <Col>
                <Button variant="secondary">Limpiar Formulario</Button>
              </Col>
              <Col>
                <Button
                  type="submit"
                  variant="primary"
                  onClick={(e) => saveForm(e)}
                >
                  Guardar Informacion
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormUser;
